import { render, staticRenderFns } from "./MatrAddMain.vue?vue&type=template&id=be2c155c&scoped=true&"
import script from "./MatrAddMain.vue?vue&type=script&lang=js&"
export * from "./MatrAddMain.vue?vue&type=script&lang=js&"
import style0 from "./MatrAddMain.vue?vue&type=style&index=0&id=be2c155c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be2c155c",
  null
  
)

export default component.exports